import { Drawer, Empty, Space, Timeline, Typography } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

const { Text } = Typography;

interface Props {
  open: boolean;
  usuarioId: number;
  onClose: () => void;
}

type Andamento = {
  id: number;
  tipo?: string;
  descricao?: string;
  observacoes?: string;
  created_at?: string;
  criadoPor?: { tipo?: string; nome?: string; em?: string };
};

const colors: Record<string, string> = {
  MUDANCA: "orange",
  CRIACAO: "green",
  EXCLUSAO: "red",
};

export default function DrawerAndamentosUsuario({ open, usuarioId, onClose }: Props) {
  const [loading, setLoading] = useState(false);
  const [andamentos, setAndamentos] = useState<Andamento[]>([]);

  useEffect(() => {
    if (!open || !usuarioId) return;
    const buscar = async () => {
      setLoading(true);
      try {
        const token = validateToken();
        const response = await axios.get(
          `${Globais.DOMINIOBACK}/usuario/${usuarioId}/andamentos`,
          { headers: token ? { Authorization: token.AuthStr } : undefined }
        );
        const data = response.data;
        const lista = Array.isArray(data)
          ? data
          : data?.andamentos || data?.data || data?.resultado || [];
        setAndamentos(lista);
      } catch {
        setAndamentos([]);
      } finally {
        setLoading(false);
      }
    };
    buscar();
  }, [open, usuarioId]);

  return (
    <Drawer open={open} onClose={onClose} title="Andamentos do Usuário" width={600} destroyOnClose>
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <Space><Text type="secondary">Carregando andamentos...</Text></Space>
        </div>
      ) : andamentos.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nenhum andamento registrado" />
      ) : (
        <Timeline mode="left" items={andamentos.map((andamento) => {
          const data = andamento.criadoPor?.em || andamento.created_at;
          const autor = andamento.criadoPor?.tipo === "SISTEMA"
            ? "Sistema"
            : andamento.criadoPor?.nome || andamento.criadoPor?.tipo;
          return {
            color: colors[andamento.tipo || ""] || "gray",
            children: (
              <div style={{ marginBottom: 12 }}>
                <Text strong style={{ display: "block" }}>{andamento.descricao || "Registro"}</Text>
                <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
                  {data ? dayjs(data).format("DD/MM/YYYY HH:mm") : ""}
                </Text>
                <Text style={{ fontSize: 12, display: "block" }}>Tipo: {andamento.tipo || "Registro"}</Text>
                {andamento.observacoes && <Text>{andamento.observacoes}</Text>}
                {autor && <Text type="secondary" style={{ display: "block" }}>Por: {autor}</Text>}
              </div>
            ),
          };
        })} />
      )}
    </Drawer>
  );
}
